<div class="card flex justify-content-center w-full">

    <p-dialog header="{{ (current()?.id ? 'action.edit' : 'action.add') | transloco}}" [position]="'center'" [modal]="true" [(visible)]="visible" [maximizable]="true" (onHide)="close($event)"
        [style]="{ width: '40rem' }" >

        <p-editor [(ngModel)]="editorContent" [style]="{height:'200px'}"
            [modules]="{ toolbar: toolbarOptions }"></p-editor>

        <div class="flex justify-content-end gap-2">
            <p-button label="{{'action.cancel' | transloco }}" severity="secondary"
                (onClick)="close($event); " />
            <p-button label="{{'action.save' | transloco}}" (onClick)="save();" />
        </div>
    </p-dialog>

</div>
